import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material';
import {AddDataSourceComponent} from './add-data-source/add-data-source.component';

declare let $;
const incr = 5;


@Component({
  selector: 'app-datasource',
  templateUrl: './datasource.component.html',
  styleUrls: ['./datasource.component.scss']
})
export class DatasourceComponent implements OnInit {
  @Input() connectors: any;
  @Input() connectorsList: any = [];
  @Output() connectorsListAddEvent = new EventEmitter<any>();
  @Output() connectorsListDeleteEvent = new EventEmitter<any>();
  items: any[] = [];
  showDialog = false;
  nextConnectorId = 1;

  constructor(private dialog: MatDialog) {
  }

  ngOnInit() {
  }


  AddNewDataSource(): void {
    // console.log(this.connectors);
    const dialogRef: MatDialogRef<AddDataSourceComponent> = this.dialog.open(AddDataSourceComponent, {
      height: '400px',
      width: '1100px',
      panelClass: 'add-data-source-dialog-container',
      data: {
        connectors: this.connectors,
        type: 'add'
      }
    });

    dialogRef.afterClosed().subscribe((result: { connector: any; connectorImage: any; executor: any } | undefined) => {
      if (result) {
        this.connectorsListAddEvent.emit({
          id: this.nextConnectorId++,
          connector: result.connector,
          connectorImage: result.connectorImage,
          executor: result.executor,
        });
      }
    });
  }

  ConfigureDataSource(connectorItem: any) {
    const dialogRef: MatDialogRef<AddDataSourceComponent> = this.dialog.open(AddDataSourceComponent, {
      height: '400px',
      width: '1100px',
      data: {
        connectorData: connectorItem,
        connectors: this.connectors,
        type: 'edit'
      }
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }

  deleteConnector(connector: any) {
    if (confirm('Are you sure you want to delete?')) {
      const index = this.connectorsList.findIndex(e => e.id === connector.id);
      this.connectorsListDeleteEvent.emit(index);
    }
  }

  closeDialog() {
    this.showDialog = false;
  }
}
